import React from 'react';
import styled, { css } from 'styled-components';
import { theme } from '../../styles/theme';

const Badge = ({
  children,
  variant = 'primary',
  removable = false,
  onRemove,
  ...rest
}) => {
  return (
    <BadgeWrapper variant={variant} {...rest}>
      <BadgeContent>{children}</BadgeContent>
      {removable && (
        <RemoveButton onClick={onRemove} aria-label="Remove">
          ✕
        </RemoveButton>
      )}
    </BadgeWrapper>
  );
};

const variantStyles = {
  primary: css`
    background-color: ${theme.colors.primary}20;
    color: ${theme.colors.primary};
    border: 1px solid ${theme.colors.primary}40;
  `,
  secondary: css`
    background-color: ${theme.colors.secondary}20;
    color: ${theme.colors.secondary};
    border: 1px solid ${theme.colors.secondary}40;
  `,
  success: css`
    background-color: ${theme.colors.success}20;
    color: ${theme.colors.success};
    border: 1px solid ${theme.colors.success}40;
  `,
  danger: css`
    background-color: ${theme.colors.danger}20;
    color: ${theme.colors.danger};
    border: 1px solid ${theme.colors.danger}40;
  `,
  warning: css`
    background-color: ${theme.colors.warning}20;
    color: ${theme.colors.warning};
    border: 1px solid ${theme.colors.warning}40;
  `,
  info: css`
    background-color: ${theme.colors.info}20;
    color: ${theme.colors.info};
    border: 1px solid ${theme.colors.info}40;
  `,
};

const BadgeWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  border-radius: ${theme.borderRadius.full};
  padding: 0.25rem 0.75rem;
  font-size: 0.75rem;
  font-weight: 500;
  white-space: nowrap;
  margin-right: 0.5rem;
  margin-bottom: 0.5rem;
  
  ${({ variant }) => variantStyles[variant] || variantStyles.primary}
`;

const BadgeContent = styled.span`
  margin-right: ${({ removable }) => (removable ? '0.25rem' : '0')};
`;

const RemoveButton = styled.button`
  background: transparent;
  border: none;
  padding: 0;
  margin-left: 0.25rem;
  cursor: pointer;
  font-size: 0.8rem;
  line-height: 0.5;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity ${theme.transitions.fast};
  
  &:hover {
    opacity: 0.7;
  }
`;

export default Badge;
